export default {
      id: "control-usage",
      viewBox: "0 0 68 57",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#control",
      toString: function () {
        return this.url;
      }
    }